import { Color, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

interface SupplierColumnTitleProps {
  isAutoCegidIntegrationEnabled?: boolean
}

export const SupplierColumnTitle = ({ isAutoCegidIntegrationEnabled }: SupplierColumnTitleProps) => {
  const { t } = useTranslation()

  if (isAutoCegidIntegrationEnabled) {
    return (
      <Flex gap={Spacing.S4} alignItems="center">
        <Text weight="medium">{t('bills.table.column.vendor')}</Text>
        <Tooltip label={t('bills.table.column.vendor.tooltip')} placement="top">
          <Icon icon="info" color={Color.Black} />
        </Tooltip>
      </Flex>
    )
  }

  return <Text weight="medium">{t('bills.table.column.vendor')}</Text>
}
